module.exports = global["$"] = require("-!./jquery.js");


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/expose-loader?$!/home/reverb/workspace/core.deploy.production/build/src/node_modules/jquery/dist/jquery.js
// module id = 0wUG
// module chunks = 23